export const isServerSide = (): boolean => typeof window === 'undefined' || typeof document === 'undefined';
